/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_LabelInputs */

const en_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add selected event to templates`)
};

const fr_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'événement sélectionné aux modèles`)
};

const de_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge das ausgewählte Ereignis zu den Vorlagen hinzu`)
};

const it_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi l'evento selezionato ai modelli`)
};

const ru_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить выбранное событие в шаблоны`)
};

const es_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar evento seleccionado a las plantillas`)
};

const zh_cn2_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定事件添加到模板`)
};

const ja_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントをテンプレートに追加`)
};

const hi_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट को टेम्प्लेट में जोड़ें`)
};

const pt_pt2_context_menu_event_template_label = /** @type {(inputs: Context_Menu_Event_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar o evento selecionado aos modelos`)
};

/**
* | output |
* | --- |
* | "Add selected event to templates" |
*
* @param {Context_Menu_Event_Template_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_label = /** @type {((inputs?: Context_Menu_Event_Template_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_event_template_label(inputs)
	if (locale === "de") return de_context_menu_event_template_label(inputs)
	if (locale === "it") return it_context_menu_event_template_label(inputs)
	if (locale === "ru") return ru_context_menu_event_template_label(inputs)
	if (locale === "es") return es_context_menu_event_template_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_event_template_label(inputs)
	if (locale === "ja") return ja_context_menu_event_template_label(inputs)
	if (locale === "hi") return hi_context_menu_event_template_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_event_template_label(inputs)
	return en_context_menu_event_template_label(inputs)
});